import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5519f78c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-user" }
const _hoisted_2 = { class: "live-user-name" }
const _hoisted_3 = {
  key: 0,
  class: "live-user-popularity"
}

import {withDefaults, computed} from 'vue';

import {download} from 'common/util';
import {useTimStore} from 'v-store/module/tim';


export default /*#__PURE__*/_defineComponent({
  props: {
    info: { default: null },
    joinNum: { default: '' },
    showAttention: { type: Boolean, default: true }
  },
  setup(__props: any) {



const timStore = useTimStore();
const groupInfo = computed(() => timStore.groupInfo);

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!

  return (__props.info)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "user-module",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(download) && _unref(download)(...args)), ["stop"]))
      }, [
        _createVNode(_component_van_image, {
          class: "user-avatar",
          width: "56px",
          height: "56px",
          radius: "50%",
          src: __props.info.avatar
        }, null, 8 /* PROPS */, ["src"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.info.name), 1 /* TEXT */),
          (_unref(groupInfo).join_num)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "人气" + _toDisplayString(_unref(groupInfo).join_num), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        (__props.showAttention)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 0,
              class: "btn-follow",
              text: "关注",
              color: "linear-gradient(90deg, #FFA6D5 0%, #FE89C7 100%)",
              size: "mini"
            }))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})